export const STATUTS_BON = ['DISPONIBLE', 'UTILISE', 'ANNULE', 'REMPLACE'];

export function resumeCredits(credit = {}, bons = []) {
  const initial = Math.max(0, Number(credit.credits_initiaux || 0));
  const complementaires = Math.max(0, Number(credit.credits_complementaires || 0));
  const actifs = bons.filter((bon) => bon.pack_id === credit.pack_id && ['DISPONIBLE', 'UTILISE'].includes(bon.statut));
  const utilises = actifs.filter((bon) => bon.statut === 'UTILISE').length;
  const total = initial + complementaires;
  return { initial, complementaires, total, attribues: actifs.length, utilises, restants: Math.max(0, total - actifs.length) };
}

export function masquerCode(indice = '') {
  const fin = String(indice).replace(/[^A-Z0-9]/gi, '').slice(-4).toUpperCase();
  return fin ? `••••-${fin}` : '••••';
}

export function lignesCloture(commandes = []) {
  const lignes = commandes.filter((commande) => commande.statut === 'VALIDEE').flatMap((commande) => commande.lignes || []);
  const groupes = new Map();
  lignes.forEach((ligne) => {
    const cle = [ligne.produit_id || '', ligne.reference || '', ligne.designation || '', ligne.taille || '', Number(ligne.prix_unitaire_ttc || 0)].join('|');
    const courant = groupes.get(cle) || { produit_id: ligne.produit_id || null, reference: ligne.reference || '', designation: ligne.designation || '', taille: ligne.taille || '', quantite: 0, prix_unitaire_ttc: Number(ligne.prix_unitaire_ttc || 0), total_ttc: 0 };
    courant.quantite += Number(ligne.quantite || 0);
    courant.total_ttc += Number(ligne.total_ttc ?? (Number(ligne.quantite || 0) * Number(ligne.prix_unitaire_ttc || 0)));
    groupes.set(cle, courant);
  });
  return [...groupes.values()].map((ligne) => ({ ...ligne, total_ttc: Math.round(ligne.total_ttc * 100) / 100 }));
}

export function portailLocalAutorise() {
  return process.env.NODE_ENV !== 'production' || process.env.REACT_APP_BOUTIQUECLUB_ENABLED === 'true';
}
